(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6719],{

/***/ 98855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ suhlas_s_pouzivanim_cookies; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/CookiesConditions/CookiesConditions.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CookiesConditionselements__Wrapper",
  componentId: "sc-1th8x7n-0"
})(["margin-top:", ";padding:0 ", ";@media (min-width:", "px){margin-top:", ";}"], (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf));
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CookiesConditionselements__Container",
  componentId: "sc-1th8x7n-1"
})(["margin-top:", ";"], (0,polished_esm/* rem */.hO)(45));
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "CookiesConditionselements__Title",
  componentId: "sc-1th8x7n-2"
})(["font-size:", ";text-align:center;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h5;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "CookiesConditionselements__Description",
  componentId: "sc-1th8x7n-3"
})(["line-height:", ";display:flex;gap:", ";"], (0,polished_esm/* rem */.hO)(24), (0,polished_esm/* rem */.hO)(25));
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CookiesConditionselements__Label",
  componentId: "sc-1th8x7n-4"
})(["display:block;padding-bottom:", ";font-size:", ";font-weight:", ";text-align:center;"], function (prop) {
  return prop.bottom ? (0,polished_esm/* rem */.hO)(prop.bottom) : 0;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h6;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
});
var Bold = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
  displayName: "CookiesConditionselements__Bold",
  componentId: "sc-1th8x7n-5"
})([""]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CookiesConditions/CookiesConditions.tsx





var CookiesConditionsTemplate = function CookiesConditionsTemplate() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: "S\xDAHLAS S POU\u017D\xCDVAN\xCDM COOKIES"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        children: "Pravidl\xE1 pou\u017E\xEDvania cookies"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: "T\xFDmto si V\xE1s dovo\u013Eujeme informova\u0165 o pou\u017E\xEDvan\xED cookies, o \xFA\u010Deloch ich pou\u017Eitia a mo\u017Enostiach nastavenie svojho internetov\xE9ho prehliada\u010Da v pr\xEDpade, ke\u010F V\xE1m aktu\xE1lne nastavenie vyu\u017E\xEDvania cookies nevyhovuje."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        children: "\u010Co s\xFA cookies?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: "Cookies s\xFA mal\xE9 textov\xE9 s\xFAbory, ktor\xE9 m\xF4\u017Eu by\u0165 pri n\xE1v\u0161teve webov\xFDch str\xE1nok odoslan\xE9 do V\xE1\u0161ho internetov\xE9ho prehliada\u010Da a ulo\u017Een\xE9 do V\xE1\u0161ho zariadenia. S\xFAbory cookies sa ukladaj\xFA do prie\u010Dinka pre s\xFAbory internetov\xE9ho prehliada\u010Da. Cookies zvy\u010Dajne obsahuj\xFA n\xE1zov webovej str\xE1nky, z ktorej poch\xE1dzaj\xFA a d\xE1tum svojho vzniku. Pri \u010Fal\u0161ej n\xE1v\u0161teve danej webovej str\xE1nky internetov\xFD prehliada\u010D op\xE4\u0165 na\u010D\xEDta s\xFAbory cookies a tieto inform\xE1cie odo\u0161le sp\xE4\u0165 webovej str\xE1nke, ktor\xE1 cookies vytvorila."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        children: "Ak\xE9 cookies vyu\u017E\xEDvame?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: "Spolo\u010Dnos\u0165 Poradca podnikate\u013Ea, spol. s r.o. pou\u017E\xEDva na svojich webov\xFDch str\xE1nkach nasleduj\xFAce typy s\xFAborov cookies:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: "a) Nevyhnutn\xE9 cookies \u2013 tieto s\xFAbory cookies nezhroma\u017E\u010Fuj\xFA inform\xE1cie a \xFAdaje, na z\xE1klade ktor\xFDch je u\u017E\xEDvate\u013E webovej str\xE1nky individu\xE1lne identifikovate\u013En\xFD, s\xFA ale nevyhnutn\xE9 pre z\xE1kladn\xFA prev\xE1dzku na\u0161ej webov\xE9 str\xE1nky. Patria sem napr\xEDklad cookies, ktor\xE9 V\xE1m umo\u017E\u0148uj\xFA prihl\xE1si\u0165 sa do svojho \xFA\u010Dtu. Bez t\xFDchto cookies nie je mo\u017En\xE9 zabezpe\u010Dova\u0165 riadnu prev\xE1dzku na\u0161ej str\xE1nky. Ak nechcete, aby sa tieto cookies ukladali, zme\u0148te si nastavenia v prehliada\u010Di."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: "b) Funk\u010Dn\xE9 cookies - tieto s\xFAbory cookies umo\u017E\u0148uj\xFA zapam\xE4ta\u0165 sa preferencie pou\u017E\xEDvania ako napr\xEDklad nastavenie zvolen\xE9 pri prehliadan\xED nav\u0161t\xEDvenej str\xE1nky, u\u017E\xEDvate\u013Esk\xE9 meno, ob\u013E\xFAben\xE9 dokumenty at\u010F pre zlep\u0161enie u\u017E\xEDvate\u013Esk\xE9ho komfortu."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: "c) \u0160tatistick\xE9 cookies - tieto s\xFAbory cookies n\xE1m pom\xE1haj\xFA porozumie\u0165 tomu, ako n\xE1v\u0161tevn\xEDci interaguj\xFA s webov\xFDmi str\xE1nkami anonymn\xFDm zhroma\u017E\u010Fovan\xEDm a oznamovan\xEDm inform\xE1ci\xED, t\xFDm zlep\u0161ujeme na\u0161e str\xE1nky."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: "d) Marketingov\xE9 cookies - tieto s\xFAbory cookies sa pou\u017E\xEDvaj\xFA za \xFA\u010Delom poskytovania a zobrazovania reklamy na z\xE1klade z\xE1ujmov u\u017E\xEDvate\u013Eov webov\xFDch str\xE1nok alebo zhroma\u017E\u010Fovanie osobn\xFDch \xFAdajov od nich na bud\xFAce marketingov\xE9 \xFA\u010Dely. Na z\xE1klade t\xFDchto s\xFAborov je pre n\xE1s mo\u017En\xE9 relevantnej\u0161ie a efekt\xEDvnej\u0161ie zacieli\u0165 priamu marketingov\xFA komunik\xE1ciu, ale aj obmedzi\u0165 po\u010Det zobrazovan\xED reklamy."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: "e) Analytick\xE9 cookies - tieto s\xFAbory cookies sl\xFA\u017Eia na z\xEDskanie \xFAdajov o n\xE1v\u0161tevnosti webovej str\xE1nky, identifikuj\xFA p\xF4vod n\xE1v\u0161tevy a tie\u017E zis\u0165uj\xFA a zbieraj\xFA inform\xE1cie o tom, ako vyu\u017E\xEDva n\xE1v\u0161tevn\xEDk t\xFAto webov\xFA str\xE1nku a sl\xFA\u017Ei na zlep\u0161ovanie a zjednodu\u0161enie pou\u017E\xEDvate\u013Esk\xE9ho rozhrania str\xE1nky."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        children: "Za ak\xFDm \xFA\u010Delom cookies vyu\u017E\xEDvame?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: "S\xFAbory cookies umo\u017E\u0148uj\xFA na\u0161ej webovej str\xE1nke rozpozn\xE1va\u0165 Va\u0161e zariadenie a zapam\xE4ta\u0165 si ur\u010Dit\xE9 inform\xE1cie o V\xE1s a Va\u0161ich aktivit\xE1ch vykonan\xFDch po\u010Das pripojenia na na\u0161u webov\xFA str\xE1nku. Cookies pou\u017E\xEDvame s cie\u013Eom optim\xE1lne vytv\xE1ra\u0165 a neust\xE1le skvalit\u0148ova\u0165 na\u0161e slu\u017Eby, prisp\xF4sobi\u0165 ich Va\u0161im z\xE1ujmom, potreb\xE1m a zlep\u0161ova\u0165 ich \u0161trukt\xFAru i obsah."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        children: "M\xF4\u017Eem si zmeni\u0165 nastavenia s\xFAborov cookies?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: "Pou\u017E\xEDvanie cookies a ich povolenie vo webovom prehliada\u010Di je na Va\u0161om rozhodnut\xED. Treba v\u0161ak pam\xE4ta\u0165 na to, \u017Ee v pr\xEDpade zmeny ich nastavenia m\xF4\u017Ee d\xF4js\u0165 k obmedzeniu funk\u010Dnosti webovej str\xE1nky a na zn\xED\u017Eenie u\u017E\xEDvate\u013Esk\xE9ho komfortu."
      })]
    })]
  });
};

/* harmony default export */ var CookiesConditions_CookiesConditions = (CookiesConditionsTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(94951);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
;// CONCATENATED MODULE: ./src/pages/suhlas-s-pouzivanim-cookies.tsx












var CookiesConditions = function CookiesConditions() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.page.common'),
      description: "",
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CookiesConditions_CookiesConditions, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var suhlas_s_pouzivanim_cookies = (CookiesConditions);

/***/ }),

/***/ 91255:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suhlas-s-pouzivanim-cookies",
      function () {
        return __webpack_require__(98855);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,4623,9774,2888,179], function() { return __webpack_exec__(91255); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);